import L from "leaflet";

const make = (kind, label) =>
  L.divIcon({
    className: "lux-pin-wrap",
    html: `<div class="lux-pin lux-pin--${kind}"><span>${label}</span></div>`,
    iconSize: [34, 34],
    iconAnchor: [17, 41],
  });

export const PIN_ICONS = { pickup: make("pickup", "A"), dropoff: make("dropoff", "B") };
